import React from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { HubButton } from "../../components";
import { useShippingContext } from "../../hooks";

import ShippingFilters from "./ShippingFilters";

const buttonProps = {
  size: "xsmall",
  iconProps: { size: 10 },
};

const ShippingBar = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { count, getIds = () => {}, onClear = () => {} } = useShippingContext();

  const onFilter = () => {
    const ids = getIds();
    setSearchParams((prev) => {
      if (prev?.has("lineItemIds")) {
        prev.delete("lineItemIds");
        return prev;
      }
      const lineItemIds = ids.join("-");
      prev.append("lineItemIds", lineItemIds);
      return prev;
    });
  };
  const hasFilter = searchParams.has("lineItemIds");
  const buttonFilterProps = hasFilter
    ? {
        label: `Clear ${count} Lines Filter`,
        icon: "X",
        variant: "contained",
        color: "info",
      }
    : {
        label: `Filter ${count} Line Items`,
        icon: "Menu",
        variant: "outlined",
        color: "neutral",
      };

  return (
    <Stack
      direction={{ lg: "row", md: "column-reverse" }}
      justifyContent={{ lg: "space-between", md: "center" }}
      alignItems={{ lg: "center", md: "end" }}
      gap="15px"
    >
      <ShippingFilters />
      <Stack direction={{ lg: "row", md: "row" }} gap="5px" alignItems="center">
        {!!count && (
          <>
            <HubButton
              label={`Clear ${count} Selected`}
              icon="X"
              variant="contained"
              color="grey"
              onClick={onClear}
              {...buttonProps}
            />
            <HubButton
              onClick={onFilter}
              {...buttonFilterProps}
              {...buttonProps}
            />
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default ShippingBar;
